// What the bees in the home page hero work on (Hero.jsx). Each job's words are in
// landing.json under hero.jobs.<key> (doing: the line while it works, result: how it
// ends); `asks` jobs end waiting for your OK. Looks are bot bees as the app draws them
// (bees/beeSvg.js species and accessories), the queen is BusyBee herself.
import { HONEY } from '../bees/beeSvg';

const LOOKS = {
  research: { species: 'cmeliak', color: '#0891B2', accessory: 'glasses' },
  writer: { species: 'orchidea', color: '#8B5CF6', accessory: 'beret' },
  books: { species: 'robotnica', color: '#16A34A', accessory: 'bowtie' },
  support: { species: 'murarka', color: '#E11D48', accessory: 'headphones' },
  travel: { species: 'drevarka', color: '#F97316', accessory: 'flower' },
  tester: { species: 'cmeliak', color: '#0EA5E9' },
  queen: { species: 'kralovna', color: HONEY },
};

export const HERO_JOBS = [
  { key: 'suppliers', look: LOOKS.research },
  { key: 'reply', look: LOOKS.writer, asks: true },
  { key: 'invoices', look: LOOKS.books },
  { key: 'flights', look: LOOKS.travel, asks: true },
  { key: 'support', look: LOOKS.support },
  { key: 'call_notes', look: LOOKS.queen },
  { key: 'site_check', look: LOOKS.tester },
  { key: 'thursday', look: LOOKS.queen },
];
